import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { ProductTraditionalDiscountMessageDS } from './product-traditional-discount-message-ds'
import { ProductTraditionalDiscountMessageLegacy } from './product-traditional-discount-message-legacy'

import type { ProductTraditionalDiscountMessageProps } from './product-traditional-discount-message.types'

export type { ProductTraditionalDiscountMessageProps }

export const ProductTraditionalDiscountMessage = (props: ProductTraditionalDiscountMessageProps) => {
  if (shouldUseDesignSystem()) {
    return <ProductTraditionalDiscountMessageDS {...props} />
  }
  return <ProductTraditionalDiscountMessageLegacy {...props} />
}

export default ProductTraditionalDiscountMessage
